// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--2d913";
export var layout = "Footer-module--layout--17146";
export var top = "Footer-module--top--7365c";
export var logoContainer = "Footer-module--logoContainer--c0ea8";
export var logo = "Footer-module--logo--2eef9";
export var navigation = "Footer-module--navigation--6d64c";
export var link = "Footer-module--link--e0d8f";
export var info = "Footer-module--info--fb109";
export var address = "Footer-module--address--e79cb";
export var contacts = "Footer-module--contacts--01560";
export var contact = "Footer-module--contact--2fc21";
export var icon = "Footer-module--icon--1f586";
export var contactText = "Footer-module--contactText--aaa48";
export var scrollArrow = "Footer-module--scrollArrow--36ceb";
export var bottom = "Footer-module--bottom--217fa";
export var copyrightWrapper = "Footer-module--copyrightWrapper--d33da";
export var copyright = "Footer-module--copyright--a775b";
export var privacyPolicy = "Footer-module--privacyPolicy--52664";